export const pricingRulesetType = ["fixed", "percentage"] as const;

export type PricingRulesetType = (typeof pricingRulesetType)[number];
export const PricingRulesetType = pricingRulesetType;
